import { stateName } from './constants'
import { AllState, State } from './types'

const localState = (state: AllState): State => state[stateName]

export const getIsFeatureSwitchEnabled =
  (name: string) =>
  (state: AllState): boolean =>
    localState(state)[name] || false
